import React from 'react';

import { observer } from 'mobx-react';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import { SortButtons } from '../../../../shared/components/buttons';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { SetupStatusTab } from '../../../interfaces/ScanIqCustomerSetupInfo';
import { useScanIqCustomerListStore } from '../hooks/useScanIqCustomerListStore';

type TitleRowProps = {
  setupStatus: SetupStatusTab;
};

const TitleRow = observer(({ setupStatus }: TitleRowProps) => {
  const { filterMethods } = useScanIqCustomerListStore(setupStatus);
  const { isSuperAdmin } = loggedInUserDataStore;

  const { handleSort, getIsSortedBy } = filterMethods;

  return (
    <GridTableRow variant="header">
      <GridTableCell>
        <SortButtons
          fieldName="FULL_NAME"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Customer
        </SortButtons>
      </GridTableCell>
      {isSuperAdmin && <GridTableCell>Entity</GridTableCell>}
      <GridTableCell>
        <SortButtons
          fieldName="INITIAL_SCAN_DATE"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Initial Scan Date
        </SortButtons>
      </GridTableCell>
      <GridTableCell>
        <SortButtons
          fieldName="LAST_SCAN_DATE"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Last Scan Date
        </SortButtons>
      </GridTableCell>
      <div />
    </GridTableRow>
  );
});

export { TitleRow };
